<div 
    *ngFor="let contentElement of element.content" 
    [ngStyle]="getElementStyle(contentElement)"
>
    <element-render 
        [contentElement]="contentElement" 
        [questionState]="questionState"
        [isLocked]="isLocked"
    ></element-render>
</div> 
